import React from "react";
import { useSelector } from "react-redux";
import SuperAdminRoutes from "./SuperAdminRoutes";
import FarmerRoutes from "./FarmerRoutes";
import SupervisorRoutes from "./SupervisorRoutes";
import DriverRoutes from "./DriverRoutes";

export default function AppRoutes() {
  // Redux State
  const role = useSelector((state) => state.auth.dataToken.roleId.roleName);
  return (
    <div>
      {(role === "super-admin" || role === "admin") && <SuperAdminRoutes />}
      {role === "supervisor" && <SupervisorRoutes />}
      {(role === "farmer" || typeof role === "undefined") && <FarmerRoutes />}
      {role === "driver" && <DriverRoutes />}
    </div>
  );
}
